/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useLicense = _interopRequireDefault(require("./useLicense"));
var _LicenseNotice = _interopRequireDefault(require("./LicenseNotice"));
var _default = {
  name: 'license',
  hook: _useLicense.default,
  defaultProps: function defaultProps() {
    return {};
  },
  renderLicenseNotice: function renderLicenseNotice() {
    return _react.default.createElement(_LicenseNotice.default, null);
  }
};
exports.default = _default;